import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPropertyVehicleCreateRequestDTO,
	postPropertyVehicleV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePostPropertyVehicleMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			(requestContract: ClientPropertyVehicleCreateRequestDTO) =>
				postPropertyVehicleV2(requestContract),
		),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: PortfolioKeys.propertyList() });
		},
	});
};
